/* NIGHT OPERATORS HYBRID page script. V1 17 Oct 2026 (lane HYBRID-LANDER-1017), V2 18 Oct 2026 (lane
   HYBRID-LANDER-V2): gallery, setup picker (top cards and bottom pills stay in step), one press adds every part
   of the picked setup through /cart/add.js, reticle and zoom pickers, sticky buy bar.
   Only the hybrid-lander templates load this file. No em or en dashes. */
(function () {
  if (window.__hyV2) return; window.__hyV2 = true;
  var top = document.getElementById('hy-top');
  var root = document.getElementById('no-hybrid');
  var data = null;
  try { data = JSON.parse(top.querySelector('[data-hy-data]').textContent); } catch (e) { data = null; }

  /* money in the shop's own format: the page prints 123456789 through Liquid's money filter, we copy its shape */
  function fmt(c) {
    var t = (data && data.money) || '$1,234,567.89';
    var n = (c / 100).toFixed(2).split('.'), i = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (t.indexOf('1,234,567.89') > -1) return t.replace('1,234,567.89', i + '.' + n[1]);
    if (t.indexOf('1.234.567,89') > -1) return t.replace('1.234.567,89', i.replace(/,/g, '.') + ',' + n[1]);
    if (t.indexOf('1,234,568') > -1) return t.replace('1,234,568', Math.round(c / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
    return '$' + i + '.' + n[1];
  }
  function all(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }

  /* gallery: a scroll snap strip, thumbs jump to a slide, the strip tells the thumbs where it is */
  if (top) {
    var stage = top.querySelector('[data-hy-stage]'), thumbs = top.querySelectorAll('[data-hy-thumb]');
    if (stage && thumbs.length) {
      thumbs.forEach(function (b) {
        b.addEventListener('click', function () {
          var i = +b.getAttribute('data-hy-thumb');
          stage.scrollTo({ left: i * stage.clientWidth, behavior: 'smooth' });
        });
      });
      var t0 = null;
      stage.addEventListener('scroll', function () {
        clearTimeout(t0);
        t0 = setTimeout(function () {
          var i = Math.round(stage.scrollLeft / Math.max(1, stage.clientWidth));
          thumbs.forEach(function (b, k) { b.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
        }, 80);
      }, { passive: true });
      stage.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        stage.scrollBy({ left: (e.key === 'ArrowRight' ? 1 : -1) * stage.clientWidth, behavior: 'smooth' });
      });
    }
  }

  /* setups */
  var pick = 'a';
  function setup() { return data && data.setups ? data.setups[pick] : null; }
  function render() {
    var s = setup(); if (!s) return;
    all('[data-hy-setup]').forEach(function (el) { el.setAttribute('aria-checked', el.getAttribute('data-hy-setup') === pick ? 'true' : 'false'); });
    all('[data-hy-setimg-a]').forEach(function (im) {
      var u = im.getAttribute('data-hy-setimg-' + pick) || im.getAttribute('data-hy-setimg-a');
      if (u && im.getAttribute('src') !== u) im.setAttribute('src', u);
      var al = im.getAttribute('data-hy-setalt-' + pick); if (al) im.setAttribute('alt', al);
      ['a', 'b'].forEach(function (k) { var p = im.getAttribute('data-hy-setimg-' + k); if (p && !im['_pre' + k]) { im['_pre' + k] = new Image(); im['_pre' + k].src = p; } });
    });
    all('[data-hy-pickname]').forEach(function (el) { el.textContent = s.name; });
    all('[data-hy-total]').forEach(function (el) { el.textContent = fmt(s.total); });
    all('[data-hy-q]').forEach(function (el) { el.textContent = fmt(Math.floor((s.total + 3) / 4)); });
    all('[data-hy-addamt]').forEach(function (el) { el.textContent = s.ok ? fmt(s.total) : ''; });
    all('[data-hy-add]').forEach(function (b) {
      b.disabled = !s.ok;
      var l = b.querySelector('[data-hy-addlabel]');
      var txt = data.preview ? 'PREVIEW ONLY' : (s.ok ? 'ADD TO CART' : 'SOLD OUT');
      if (l) l.textContent = txt; else b.textContent = data.preview ? 'PREVIEW' : txt;
    });
    var ul = top && top.querySelector('[data-hy-lines]');
    if (ul) {
      ul.innerHTML = '';
      s.lines.forEach(function (ln) {
        var li = document.createElement('li'), sp = document.createElement('span'), sm = document.createElement('small'), b = document.createElement('b');
        sp.textContent = ln.name; sm.textContent = 'qty 1'; sp.appendChild(sm); if (ln.was) { var ws = document.createElement('s'); ws.textContent = fmt(ln.was); b.appendChild(ws); b.appendChild(document.createTextNode(' FREE')); } else { b.textContent = fmt(ln.price); }
        li.appendChild(sp); li.appendChild(b); ul.appendChild(li);
      });
    }
  }
  if (data && data.setups) {
    all('[data-hy-sprice]').forEach(function (el) {
      var s = data.setups[el.getAttribute('data-hy-sprice')];
      if (s) el.textContent = s.ok || data.preview ? fmt(s.total) : 'Sold out';
      if (s && !s.ok && !data.preview) { var c = el.closest('[data-hy-setup]'); if (c) { c.setAttribute('aria-disabled', 'true'); } }
    });
    document.addEventListener('click', function (e) {
      var c = e.target.closest && e.target.closest('[data-hy-setup]');
      if (!c || c.getAttribute('aria-disabled') === 'true') return;
      pick = c.getAttribute('data-hy-setup'); render();
    });
    document.addEventListener('keydown', function (e) {
      var c = e.target.closest && e.target.closest('[data-hy-setup]');
      if (!c || (e.key !== 'Enter' && e.key !== ' ')) return;
      if (c.tagName !== 'BUTTON') e.preventDefault();
      if (c.getAttribute('aria-disabled') === 'true') return;
      pick = c.getAttribute('data-hy-setup'); render();
    });
    render();
  }

  /* one press, every line of the setup, then the cart page */
  function add(btn) {
    var s = setup(); if (!s || !s.ok || (data && data.preview)) return;
    var errs = all('[data-hy-err]');
    errs.forEach(function (e) { e.hidden = true; });
    all('[data-hy-add]').forEach(function (b) { b.disabled = true; });
    fetch(data.cartAdd, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: s.lines.map(function (l) { return { id: l.id, quantity: 1 }; }) })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (x) {
        if (!x.ok) throw new Error((x.j && (x.j.description || x.j.message)) || 'Could not add to cart');
        if (window.noCartDrawerOpen) { render(); window.noCartDrawerOpen(x.j); return; }
        window.location.href = data.cartUrl;
      })
      .catch(function (e) {
        errs.forEach(function (el) { el.textContent = e.message + '. Please try again, or email info@nightoperators.com.'; el.hidden = false; });
        render();
      });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-hy-add]');
    if (!b) return;
    e.preventDefault(); add(b);
  });
  var form = top && top.querySelector('[data-hy-form]');
  if (form) form.addEventListener('submit', function (e) { e.preventDefault(); add(); });

  if (!root) return;
  function press(group, btn) {
    group.querySelectorAll('.hy-sw').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
  }
  var ret = root.querySelector('[data-hy-ret]');
  if (ret) {
    var ring = ret.querySelector('[data-hy-ring]'), dot = ret.querySelector('[data-hy-dot]'), cap = ret.querySelector('[data-hy-rcap]');
    var caps = {
      dot: 'Dot only: a small, precise aim point.',
      circle: 'Circle only: a big ring that is fast to find up close.',
      both: 'Dot and circle together: the circle for fast close shots, the dot for precise ones.'
    };
    ret.addEventListener('click', function (e) {
      var b = e.target.closest('[data-hy-r]'); if (!b) return;
      var r = b.getAttribute('data-hy-r'); press(ret, b);
      if (ring) { if (r === 'dot') ring.setAttribute('hidden', ''); else ring.removeAttribute('hidden'); }
      if (dot) { if (r === 'circle') dot.setAttribute('hidden', ''); else dot.removeAttribute('hidden'); }
      if (cap) cap.textContent = caps[r] || '';
    });
  }
  var zm = root.querySelector('[data-hy-zoom]');
  if (zm) {
    var val = zm.querySelector('[data-hy-zval]'), zcap = zm.querySelector('[data-hy-zcap]');
    var zcaps = {
      '1': 'Digital zoom on the thermal picture only. The red dot window itself always stays at true 1x.',
      '3': '3x on the thermal picture: a closer look at a warm shape before you commit.',
      '5': '5x on the thermal picture: the closest look. The window stays 1x for the red dot.'
    };
    zm.addEventListener('click', function (e) {
      var b = e.target.closest('[data-hy-z]'); if (!b) return;
      var z = b.getAttribute('data-hy-z'); press(zm, b);
      if (val) val.textContent = z + 'X';
      if (zcap) zcap.textContent = zcaps[z] || '';
    });
  }

  /* sticky buy bar: shows once the top buy box is scrolled past, hides while the order section is on screen */
  var bar = root.querySelector('[data-hy-sticky]');
  var start = (top && top.querySelector('[data-hy-add]')) || root.querySelector('#hy-hero');
  var buy = root.querySelector('#hy-buy');
  if (bar && start && buy) {
    var raf = 0;
    function sync() {
      raf = 0;
      var vh = window.innerHeight, s = start.getBoundingClientRect(), y = buy.getBoundingClientRect();
      var on = s.bottom < 0 && !(y.top < vh && y.bottom > 0);
      bar.classList.toggle('hy-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      bar.querySelectorAll('button').forEach(function (b) { b.tabIndex = on ? 0 : -1; });
    }
    function ask() { if (!raf) raf = requestAnimationFrame(sync); }
    window.addEventListener('scroll', ask, { passive: true });
    window.addEventListener('resize', ask);
    sync();
  }
})();
